import { _ as _defineProperty } from '../defineProperty-1e8516b1.js';
import { jsx } from '@emotion/react/jsx-runtime';
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var shouldRenderItem = function shouldRenderItem(item, definitions, context) {
  var itemDefition = definitions[item.type];
  if (itemDefition.component) {
    var shouldRenderComponent = itemDefition.shouldRenderComponent;
    if (shouldRenderComponent && !shouldRenderComponent(item, context)) {
      return false;
    }
    return true;
  }
  return true;
};
var renderItem = function renderItem(item, definitions, context) {
  var itemDefition = definitions[item.type];
  if (itemDefition.component) {
    var Component = itemDefition.component,
      shouldRenderComponent = itemDefition.shouldRenderComponent;
    if (shouldRenderComponent && !shouldRenderComponent(item, context)) {
      return null;
    } // eslint-disable-next-line @typescript-eslint/no-explicit-any

    return jsx(Component, _objectSpread({}, item));
  }
  return itemDefition.render(item, context);
};
export { renderItem, shouldRenderItem };